import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { AtivityLogItem } from '@shared/api/services/ativity-logs.service';
import { resolverVisualAcao } from '../registos-acao-visual';

@Component({
  selector: 'app-detalhe-registo-drawer',
  standalone: true,
  imports: [CommonModule, DrawerModule],
  templateUrl: './detalhe-registo-drawer.component.html',
  styleUrl: './detalhe-registo-drawer.component.scss',
})
export class DetalheRegistoDrawerComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() log: AtivityLogItem | null = null;

  readonly semValor = 'Sem valor';

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  formatValor(valor: unknown): string {
    if (this.valorAusente(valor)) return this.semValor;
    if (typeof valor === 'object') {
      try {
        return JSON.stringify(valor);
      } catch {
        return String(valor);
      }
    }
    return String(valor);
  }

  private valorAusente(valor: unknown): boolean {
    if (valor === null || valor === undefined) return true;
    if (typeof valor !== 'string') return false;
    const texto = valor.trim();
    return texto === '' || texto === '-';
  }

  temValorAnterior(): boolean {
    return !this.valorAusente(this.log?.valorAnterior);
  }

  temValorNovo(): boolean {
    return !this.valorAusente(this.log?.valorNovo);
  }

  temAlteracao(): boolean {
    return this.formatValor(this.log?.valorAnterior) !== this.formatValor(this.log?.valorNovo);
  }

  getAcaoClass(acaoEnum?: number, acaoLabel?: string): string {
    return resolverVisualAcao(acaoEnum, acaoLabel).badge;
  }

  getAcaoIcon(acaoEnum?: number, acaoLabel?: string): string {
    return resolverVisualAcao(acaoEnum, acaoLabel).icon;
  }
}
